var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00493 4.04096L6.00497 4.04093C7.59708 2.42369 9.7519 1.51151 12.0002 1.50001C14.2485 1.51151 16.4029 2.42385 17.995 4.04109L17.9951 4.04113C19.5879 5.65873 20.489 7.85145 20.5 10.1425V10.4468C20.4967 12.5527 19.7295 14.5822 18.347 16.1478L12.7994 22.1315C12.5831 22.3545 12.2935 22.4853 11.9889 22.5L11.9569 22.5L11.9556 22.5C11.6751 22.5007 11.4047 22.3866 11.206 22.181L5.95979 16.1975L5.95992 16.1973L5.95116 16.1879C4.43331 14.5443 3.56063 12.391 3.50003 10.1359C3.51274 7.84721 4.41363 5.65705 6.00493 4.04096Z",
    stroke: "#222222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 4.5,
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e52e52a030fc860b8f8926409965d3a9.svg";
export { ForwardRef as ReactComponent };